module.exports = __webpack_public_path__ + "img/customer-usecase-04.f098c166.jpg";